module.exports = __webpack_public_path__ + "img/FR13558.064f324c.png";